import {
  showCookesPolicyModal,
  showPrivacyPolicyModal,
} from '../redux/actions/app'
import React from 'react'
import { useDispatch } from 'react-redux'
import { tt } from '../i18n'

interface Props {
  ctaText: string
}

export default function GDPRReminder(props: Props) {
  const dispatch = useDispatch()
  return (
    <p className="w-margin-bottom-half">
      <small>
        {tt('gdpr_reminder_prefix')} "{props.ctaText}",{' '}
        {tt('gdpr_reminder_accepts_rules')}{' '}
        <span
          style={{
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
          onClick={() => dispatch(showPrivacyPolicyModal())}
        >
          {tt('gdpr_reminder_privacy_policy')}
        </span>{' '}
        {tt('gdpr_reminder_and')}{' '}
        <span
          style={{
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
          onClick={() => dispatch(showCookesPolicyModal())}
        >
          {tt('gdpr_reminder_cookies_policy')}
        </span>
      </small>
    </p>
  )
}
